/**
 * bulletins.js
 * ------------
 * Cycle de bulletins et seances de conseil de classe.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Cycle de bulletins (campagne, avancement, verrouillage) ── */

/** GET /directeur/bulletins/campagnes/ -> { campagnes, periodes, types_livret, annee } */
export async function getCampagnesBulletins(params = {}) {
  const { data } = await axiosClient.get("/directeur/bulletins/campagnes/", { params });
  return data || {};
}

/** POST /directeur/bulletins/campagnes/ — crée une campagne en préparation. */
export async function creerCampagneBulletins(payload) {
  const { data } = await axiosClient.post("/directeur/bulletins/campagnes/", payload);
  return data;
}

/** GET /directeur/bulletins/campagnes/<id>/avancement/ -> { campagne, avancement } */
export async function getAvancementCampagne(id) {
  const { data } = await axiosClient.get(`/directeur/bulletins/campagnes/${id}/avancement/`);
  return data || {};
}

/**
 * POST /directeur/bulletins/campagnes/<id>/transition/ — fait avancer le cycle.
 * @param {"ouvrir"|"verrouiller"|"rouvrir"|"publier"|"annuler"} action
 */
export async function transitionCampagne(id, action) {
  const { data } = await axiosClient.post(
    `/directeur/bulletins/campagnes/${id}/transition/`,
    { action },
  );
  return data;
}

/** POST /directeur/bulletins/campagnes/<id>/relancer/ — relance les retardataires. */
export async function relancerCampagne(id) {
  const { data } = await axiosClient.post(`/directeur/bulletins/campagnes/${id}/relancer/`, {});
  return data;
}

/** GET /directeur/bulletins/campagnes/<id>/conseils/ -> { seances, date_conseil } */
export async function getSeancesConseil(campagneId) {
  const { data } = await axiosClient.get(
    `/directeur/bulletins/campagnes/${campagneId}/conseils/`,
  );
  return data || {};
}

/** POST /directeur/bulletins/campagnes/<id>/conseils/ — (re)planifie les séances. */
export async function planifierConseils(campagneId, payload = {}) {
  const { data } = await axiosClient.post(
    `/directeur/bulletins/campagnes/${campagneId}/conseils/`,
    payload,
  );
  return data;
}
